<script>

  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        required: true,
      },
      okText: {
        type: String,
        default: 'Refresh Now'
      },
      cancelText: {
        type: String,
        default: 'No, not now'
      },
    },
    data() {
      return {
      }
    },
    computed: {
      id(){
        return 'reload-modal'
      },
      messageSegments(){
        return this.message.split('\\n')
      }
    },
    methods: {
      close(){
        this.$customModal.hide(this.id)
        this.$emit('reloadModalClosed')
      },
      confirm(){
        this.$customModal.hide(this.id)
        this.$emit('reloadModalConfirmed')
      }
    },
  }
</script>

<template>
  <FabricModal
    :id="id"
    :heading="title"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
    header-class="border-bottom-primary pd-x-0-f tw-border-b-2 tw-border-primary"
    footer-class="tw-flex tw-flex-col md:tw-flex-row"
  >
    <!-- Header -->
    <template v-slot:modal-header>
      <div class="custom-border-header-content mg-x-15 text-primary">
        <h5 class="h5 mg-b-u tx-weight-bold tw-pl-3">{{title}}</h5>
      </div>
    </template>
    <!-- Footer -->
    <template v-slot:modal-footer>
      <section>
        <button type="button" class="tw-border-orange-400 tw-border tw-bg-orange-400 hover:tw-bg-orange-400/50 hover:tw-text-orange-600 tx-weight-bold border-rounded-20 mn-h-46 f-w-180 tx-tf-upper" @click="close">{{cancelText}}</button>
      </section>
      <section>
        <button type="button" class="border-blue tw-border bg-col-white hover:tw-bg-positive col-blue hover:tw-text-white tx-weight-bold border-rounded-20 mn-h-46 f-w-180 tx-tf-upper" @click="confirm">{{okText}}</button>
      </section>
    </template>
    <!-- Body -->
    <template v-slot:modal-body>
      <section>
        <p v-if="messageSegments.length <= 1" class="tx-weight-bold tw-px-3">{{message}}</p>
        <section v-else>
          <p v-for="(segment, index) in messageSegments" :key="index" class="tx-weight-bold tw-px-3 mn-h-1r">{{segment}}</p>
        </section>
      </section>
    </template>
  </FabricModal>
</template>
